/* eslint-disable react/prefer-stateless-function,no-unused-vars,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  selectAllErrors,
  selectSendRequestState
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';

import {
  changeFieldTimeTargetDeleteTimeRange,
  changeFieldTimeTargetChangeRangeFrom,
  changeFieldTimeTargetChangeRangeTo,
  changeFieldTimeTargetChangeMaxAmount
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { t } from 'utils/translates';
import _ from 'lodash';

class TimeTargetWeekDaysTimeRangeItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoursArr: Array(...{ length: 24 }).map(Number.call, Number => {
        const hour = Number.toString();
        return hour.length === 1 ? `0${hour}` : hour;
      }),
      minutesArr: ['00', '10', '20', '30', '40', '50', '59'],
      minutesArrNotRoundHour: ['10', '20', '30', '40', '50', '59']
    };
    this.inputsRefs = {
      [props.timeRangeItem.field]: React.createRef()
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.sendRequestState.countQueries >
        prevProps.sendRequestState.countQueries &&
      !_.isEmpty(this.props.allErrors)
    ) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      const scrollRef = this.inputsRefs[firstErrorField];
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  getHoursFromTime = time => time.split(':')[0];

  getMitutesFromTime = time => time.split(':')[1];

  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };

    const hoursFrom = this.props.timeRangeItem.value.time_from.split(':')[0];
    const minutesFrom = this.props.timeRangeItem.value.time_from.split(':')[1];
    const hoursTo = this.props.timeRangeItem.value.time_to.split(':')[0];
    const minutesTo = this.props.timeRangeItem.value.time_to.split(':')[1];
    const maxAmount = this.props.timeRangeItem.value.max_amount;
    return (
      <React.Fragment>
        <div
          ref={this.inputsRefs[this.props.timeRangeItem.field]}
          className={`form-inline text-nowrap form-inline_no-breakpoint m-b-15 ${
            hasError(this.props.timeRangeItem.errors) ? 'has-error' : ''
          }`}
        >
          <div className="form-group m-b-0">
            <p className="form-control-static">
              {this.props.timeRangeIndex + 1}.
            </p>
          </div>
          <div className="form-group m-b-0">
            <div className="input-group">
              <div className="btn-group bootstrap-select input-group-btn form-control text-center ng-untouched ng-pristine ng-valid">
                <button
                  type="button"
                  className="btn dropdown-toggle btn-default"
                  data-toggle="dropdown"
                  data-id="periodTimeFromH0-0"
                  title={hoursFrom}
                >
                  <span className="filter-option pull-left">{hoursFrom}</span>
                  &nbsp;
                  <span className="bs-caret">
                    <span className="caret" />
                  </span>
                </button>
                <div className="dropdown-menu open">
                  <ul
                    className="dropdown-menu inner"
                    role="listbox"
                    aria-expanded="false"
                  >
                    {this.state.hoursArr.map(value => (
                      <li
                        key={`hoursFrom-${value}`}
                        data-original-index="0"
                        className={hoursFrom === value ? 'selected' : ''}
                      >
                        <a
                          tabIndex="0"
                          className=""
                          data-tokens="null"
                          role="option"
                          aria-disabled="false"
                          aria-selected="true"
                          onClick={() => {
                            this.props.changeFieldTimeTargetChangeRangeFrom(
                              `${value}:${minutesFrom}`
                            );
                          }}
                        >
                          <span className="text">{value}</span>
                          <span className="glyphicon glyphicon-ok check-mark" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <span className="input-group-addon">:</span>
              <div className="btn-group bootstrap-select input-group-btn form-control text-center ng-untouched ng-pristine ng-valid">
                <button
                  type="button"
                  className="btn dropdown-toggle btn-default"
                  data-toggle="dropdown"
                  data-id="periodTimeFromM0-0"
                  title={minutesFrom}
                >
                  <span className="filter-option pull-left">{minutesFrom}</span>
                  &nbsp;
                  <span className="bs-caret">
                    <span className="caret" />
                  </span>
                </button>
                <div className="dropdown-menu open">
                  <ul
                    className="dropdown-menu inner"
                    role="listbox"
                    aria-expanded="false"
                  >
                    {this.state.minutesArr.map(value => (
                      <li
                        key={`minutesFrom-${value}`}
                        data-original-index="0"
                        className={minutesFrom === value ? 'selected' : ''}
                      >
                        <a
                          tabIndex="0"
                          className=""
                          data-tokens="null"
                          role="option"
                          aria-disabled="false"
                          aria-selected="true"
                          onClick={() => {
                            this.props.changeFieldTimeTargetChangeRangeFrom(
                              `${hoursFrom}:${value}`
                            );
                          }}
                        >
                          <span className="text">{value}</span>
                          <span className="glyphicon glyphicon-ok check-mark" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <p className="form-control-static">&nbsp; – &nbsp;</p>
            <div className="input-group">
              <div className="btn-group bootstrap-select input-group-btn form-control text-center ng-untouched ng-pristine ng-valid">
                <button
                  type="button"
                  className="btn dropdown-toggle btn-default"
                  data-toggle="dropdown"
                  data-id="periodTimeToH0-0"
                  title={hoursTo}
                >
                  <span className="filter-option pull-left">{hoursTo}</span>
                  &nbsp;
                  <span className="bs-caret">
                    <span className="caret" />
                  </span>
                </button>
                <div className="dropdown-menu open">
                  <ul
                    className="dropdown-menu inner"
                    role="listbox"
                    aria-expanded="false"
                  >
                    {this.state.hoursArr.map(value => (
                      <li
                        key={`hoursTo-${value}`}
                        data-original-index="0"
                        className={hoursTo === value ? 'selected' : ''}
                      >
                        <a
                          tabIndex="0"
                          className=""
                          data-tokens="null"
                          role="option"
                          aria-disabled="false"
                          aria-selected="true"
                          onClick={() => {
                            this.props.changeFieldTimeTargetChangeRangeTo(
                              `${value}:${minutesTo}`
                            );
                          }}
                        >
                          <span className="text">{value}</span>
                          <span className="glyphicon glyphicon-ok check-mark" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <span className="input-group-addon">:</span>
              <div className="btn-group bootstrap-select input-group-btn form-control text-center ng-untouched ng-pristine ng-valid">
                <button
                  type="button"
                  className="btn dropdown-toggle btn-default"
                  data-toggle="dropdown"
                  data-id="periodTimeToM0-0"
                  title={minutesTo}
                >
                  <span className="filter-option pull-left">{minutesTo}</span>
                  &nbsp;
                  <span className="bs-caret">
                    <span className="caret" />
                  </span>
                </button>
                <div className="dropdown-menu open">
                  <ul
                    className="dropdown-menu inner"
                    role="listbox"
                    aria-expanded="false"
                  >
                    {this.state.minutesArrNotRoundHour.map(value => (
                      <li
                        key={`minutesTo-${value}`}
                        data-original-index="0"
                        className={minutesTo === value ? 'selected' : ''}
                      >
                        <a
                          tabIndex="0"
                          className=""
                          data-tokens="null"
                          role="option"
                          aria-disabled="false"
                          aria-selected="true"
                          onClick={() => {
                            this.props.changeFieldTimeTargetChangeRangeTo(
                              `${hoursTo}:${value}`
                            );
                          }}
                        >
                          <span className="text">{value}</span>
                          <span className="glyphicon glyphicon-ok check-mark" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="form-group m-b-0">
              <p
                className="form-control-static"
                style={{ paddingLeft: '15px' }}
              >
                {t('Количество')}:
              </p>
            </div>
            <div className="input-group">
              <input
                className="form-control"
                type="number"
                placeholder={t('Без ограничений')}
                value={maxAmount}
                onChange={e => {
                  this.props.changeFieldTimeTargetChangeMaxAmount(
                    e.target.value
                  );
                }}
              />
            </div>
          </div>
          {this.props.timeRangeIndex > 0 ? (
            <div className="form-group m-b-0">
              <p className="form-control-static">
                <a
                  data-toggle="tooltip"
                  href=""
                  data-original-title={t('Удалить')}
                  onClick={e => {
                    e.preventDefault();
                    this.props.changeFieldTimeTargetDeleteTimeRange({
                      weekDaysIndex: this.props.weekDaysIndex,
                      timeRangeIndex: this.props.timeRangeIndex
                    });
                  }}
                >
                  <i className="fa fa-trash" />
                </a>
              </p>
            </div>
          ) : null}
          {errorDesc(this.props.timeRangeItem.errors)}
        </div>
      </React.Fragment>
    );
  }
}

TimeTargetWeekDaysTimeRangeItem.propTypes = {
  sendRequestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  weekDaysIndex: PropTypes.number.isRequired,
  timeRangeIndex: PropTypes.number.isRequired,
  timeRangeItem: PropTypes.shape({
    field: PropTypes.string,
    value: PropTypes.shape({
      time_from: PropTypes.string.isRequired,
      time_to: PropTypes.string.isRequired,
      max_amount: PropTypes.number.isRequired
    }),
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldTimeTargetDeleteTimeRange: PropTypes.func.isRequired,
  changeFieldTimeTargetChangeRangeFrom: PropTypes.func.isRequired,
  changeFieldTimeTargetChangeRangeTo: PropTypes.func.isRequired,
  changeFieldTimeTargetChangeMaxAmount: PropTypes.func.isRequired,
  allErrors: PropTypes.shape({}).isRequired
};

const mapStateToProps = (state, props) => ({
  allErrors: selectAllErrors(state, props.reducerName),
  sendRequestState: selectSendRequestState(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTimeTargetChangeRangeFrom: timeFrom =>
    dispatch(
      changeFieldTimeTargetChangeRangeFrom(props.reducerName, {
        weekDaysIndex: props.weekDaysIndex,
        timeRangeIndex: props.timeRangeIndex,
        timeFrom
      })
    ),
  changeFieldTimeTargetChangeRangeTo: timeTo =>
    dispatch(
      changeFieldTimeTargetChangeRangeTo(props.reducerName, {
        weekDaysIndex: props.weekDaysIndex,
        timeRangeIndex: props.timeRangeIndex,
        timeTo
      })
    ),
  changeFieldTimeTargetChangeMaxAmount: maxAmount =>
    dispatch(
      changeFieldTimeTargetChangeMaxAmount(props.reducerName, {
        weekDaysIndex: props.weekDaysIndex,
        timeRangeIndex: props.timeRangeIndex,
        maxAmount
      })
    ),
  changeFieldTimeTargetDeleteTimeRange: payload =>
    dispatch(changeFieldTimeTargetDeleteTimeRange(props.reducerName, payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeTargetWeekDaysTimeRangeItem);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/TimeTargetTaskInputs/TimeTargetWeekDaysItem/TimeTargetWeekDaysTimeRangeItem.js